module.exports = __webpack_public_path__ + "static/gravity-regular-webfont-e37762360eb5d276d1abf6d3b953ebab.woff2";